const DEBUG_NEUTRALIZED_SCRIM_SELECTOR = "body > div, [data-overlay-container] > div";
const DEBUG_NEUTRALIZED_SCRIM_Z_INDEXES = new Set(["400", "50"]);

const DEBUG_SCRIM_NEUTRALIZED_DATA_KEY = "debugScrimNeutralized";
const DEBUG_SCRIM_BACKGROUND_COLOR_DATA_KEY = "debugScrimBackgroundColor";
const DEBUG_SCRIM_BACKDROP_FILTER_DATA_KEY = "debugScrimBackdropFilter";

const isDebugNeutralizedScrimCandidate = (element: HTMLElement): boolean => {
  const style = window.getComputedStyle(element);

  return style.position === "fixed" && DEBUG_NEUTRALIZED_SCRIM_Z_INDEXES.has(style.zIndex);
};

const neutralizeScrimElement = (element: HTMLElement): void => {
  if (element.dataset[DEBUG_SCRIM_NEUTRALIZED_DATA_KEY] === "true") {
    return;
  }

  element.dataset[DEBUG_SCRIM_NEUTRALIZED_DATA_KEY] = "true";
  element.dataset[DEBUG_SCRIM_BACKGROUND_COLOR_DATA_KEY] = element.style.backgroundColor;
  element.dataset[DEBUG_SCRIM_BACKDROP_FILTER_DATA_KEY] = element.style.backdropFilter;

  element.style.backgroundColor = "transparent";
  element.style.backdropFilter = "none";
};

export const neutralizeModalScrimsForDebugPanel = (): void => {
  document.querySelectorAll("[inert]").forEach(element => {
    element.removeAttribute("inert");
  });

  document.querySelectorAll<HTMLElement>(DEBUG_NEUTRALIZED_SCRIM_SELECTOR).forEach(element => {
    if (isDebugNeutralizedScrimCandidate(element)) {
      neutralizeScrimElement(element);
    }
  });
};

export const restoreModalScrimsForDebugPanel = (): void => {
  document
    .querySelectorAll<HTMLElement>("[data-debug-scrim-neutralized='true']")
    .forEach(element => {
      element.style.backgroundColor = element.dataset[DEBUG_SCRIM_BACKGROUND_COLOR_DATA_KEY] ?? "";
      element.style.backdropFilter = element.dataset[DEBUG_SCRIM_BACKDROP_FILTER_DATA_KEY] ?? "";

      delete element.dataset[DEBUG_SCRIM_NEUTRALIZED_DATA_KEY];
      delete element.dataset[DEBUG_SCRIM_BACKGROUND_COLOR_DATA_KEY];
      delete element.dataset[DEBUG_SCRIM_BACKDROP_FILTER_DATA_KEY];
    });
};
